const yup = require("yup");

// Schema for createcollegerules
const create = yup.object({
  post: yup.string().required("Post is required"),
});

module.exports = {
  create,
};
